import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ServicehotelService } from 'src/app/api/config/servicehotel.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import AlertifyHelper from 'src/app/utils/utils';
import SwalAlert from 'src/app/utils/swalalert';
import { VoucherService } from 'src/app/api/billing/voucher.service';
declare var $: any;

@Component({
  selector: 'app-voucher-cancelled-extends',
  templateUrl: './voucher-cancelled-extends.component.html',
  styleUrls: ['./voucher-cancelled-extends.component.css']
})
export class VoucherCancelledExtendsComponent {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @Output() onSubmitEvent = new EventEmitter<string>();

  item: FormGroup;
  submitted: boolean = false;
  movement:any = {};

  constructor(
    public fb: FormBuilder,
    private serviceHotelService: ServicehotelService,
    private voucherService: VoucherService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper
  ) {
    this.item = this.fb.group({
      motive_cancelled: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(200)]],
      movement_id: [null],
      affect_moneybox: [true],
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  focused(data:any, index:any) {
    setTimeout(() => {
      (<any>$('#motive_cancelled')).focus();
    }, 500);

    this.movement = data;
    this.item.patchValue({
      movement_id:this.movement.id
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
   
    let options = {
      title: '¡Cuidado!',
      message: "¿Esta seguro(a) de anular y dar de baja el comprobante "+this.movement.nro_voucher+"?",    
      cancel: 'Cancelar',
      confirm: 'ANULAR COMPROBANTE'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.LoadingModalComponent.show();
        let data: any = {};
        data.item = this.item.value;
        this.voucherService.cancelledVoucher(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.onSubmitEvent.emit(data.data);
            this.LoadingModalComponent.hide();
            (<any>$('#openExtendsVoucherCancelled')).modal('hide');
            this.resetForm();
          }
        });
      }
    });
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
  }

  close() {
    this.item.reset();
  }
}